import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../ui/button/button.component';
import { CardComponent } from '../../../../ui/card/card.component';
import { Router, RouterOutlet } from '@angular/router';
import { TestsTabComponent } from '../../../../../shared/tables/tests-tab/tests-tab.component';
import { LearningService } from '../../../../../core/services/learning-path.service';
import { AuthService } from '../../../../../core/services/utils/auth.service';
import { SwalService } from '../../../../../core/services/utils/swal.service';
import { finalize, takeUntil } from 'rxjs';
import { SyncfusionL10nService } from '../../../../../shared/utils/syncfusion-l10n.service';
import { LanguageService } from '../../../../../core/services/utils/language.service';
import { Subject as RxJsSubject } from 'rxjs';
import { Theme } from '../../../../../core/interfaces/theme';
import { Subject } from '../../../../../core/interfaces/subject';
import { LearningPath } from '../../../../../core/interfaces/learning-path';
import {
  ProfessorLearningPathLightDto,
  ProfessorSubjectLightDto,
} from '../../../../../core/interfaces/professor';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-bank',
  standalone: true,
  imports: [
    TranslateModule,
    ButtonComponent,
    TestsTabComponent,
    FormsModule,
    RouterOutlet,
    CommonModule,
  ],
  templateUrl: './bank.component.html',
  styleUrl: './bank.component.css',
})
export class BankComponent {
  router = inject(Router);
  swal = inject(SwalService);
  translate = inject(TranslateService);

  @ViewChild(TestsTabComponent) testsTabComponent!: TestsTabComponent;

  displayTest() {
    // Le compositeur charge lui-même sa portée (parcours/matière/modules) :
    // plus besoin de pré-sélectionner un filtre pour créer un test.
    this.router.navigate(['/teacher/create-test']);
  }

}
